import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

export const salesLeadActivitiesToggleButtonSx: SxProps<Theme> = {
	minHeight: "1.75rem",
	height: "1.75rem",
	paddingX: 1,
	paddingY: 0,
	gap: 0.75,
	fontSize: "0.8125rem",
	lineHeight: 1,
	textTransform: "none",
	"& .svg-inline--fa": {
		fontSize: "0.875rem",
	},
};
